import { Observable } from 'rxjs';

export enum SyncItemType {
  FOLDER = 'folder',
  LIST = 'list',
  SINGLE = 'single',
  METADATA = 'metadata'
}

export interface SyncItem {
  id: string,
  type: SyncItemType;
  observables: Observable<any>[],
  failedObservables?: Observable<any>[],
  subfolders?: number,
  name?: string,
  currentProgress: number,
  totalProgress: number,
}